export default __webpack_public_path__ + "static/media/zayed-project-3.95f1b8d5.webp";